import { ListingParcelData } from '~/components/listing'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/components/ui'
import { cn } from '~/lib'
import type { Listing } from '~/models'

type ParcelDataDialogProps = {
  className?: string
  listing: Listing
}

export default function ParcelDataDialog({
  className,
  listing,
}: ParcelDataDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          className={cn(
            className,
            'h-auto p-0 text-base !no-underline hover:text-black print:hidden'
          )}
          size="sm"
          variant="link">
          View Parcel Data
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-lg">
        <DialogDescription className="sr-only">
          View Parcel Data
        </DialogDescription>
        <DialogHeader className="mb-2">
          <DialogTitle>Parcel Data</DialogTitle>
        </DialogHeader>
        <ListingParcelData listing={listing} contentClassName="max-h-96" />
      </DialogContent>
    </Dialog>
  )
}
